"use client";
// Components
import Link from 'next/link';
import { HiMiniSquares2X2 } from 'react-icons/hi2';
import { nanoid } from 'nanoid';
import { MoreMenuOptions } from '@ui/header/constants';

// Store
import useStore from '@store';

export default function More({}) {
	const $state = useStore();
	const { user } = $state?.auth || {};
	const role = user?.profile?.member_type.toLowerCase();

	return (
		<div
			className={`group relative px-1 py-2 border-4 w-16 rounded-md border-transparent hover:border-[#3AECF8] hover:bg-[#2096FC] hover:shadow-[0_6px_0px_0px_#3D3DB1]`}>
			<span className='flex flex-col items-center justify-between h-full gap-2 text-white'>
				<HiMiniSquares2X2 size={28} />
				<span className='text-sm'>{'More'}</span>
			</span>
			{/* This layer prevents glitchy behavion when hovering out of the menu element */}
			<div
				className={`fixed bg-transparent w-full h-[96px] left-0 z-2 -top-[3000px] transition-all duration-300 group-hover:top-0`}></div>
			{/* More Options Menu */}
			<div
				className={`flex flex-col items-start gap-1 border-4 border-[#E3E3EE] bg-[#EFEFEF] rounded-lg absolute -right-[96px] w-[200px] text-[#6666E1] -top-[3000px] transition-all duration-300 group-hover:top-full`}>
				{MoreMenuOptions.map((option) => {
					if(option.label === 'Blog' && ['child', 'student'].includes(role)) return null;

					return (
						<Link
							key={nanoid(5)}
							href={option.link}
							target={option.link.startsWith('http') ? '_blank' : undefined}
							rel={option.link.startsWith('http') ? 'noopener noreferrer' : undefined}
							className={`flex flex-row w-full items-center gap-2 font-bold text-lg py-2 px-4 transition-all duration-300 hover:bg-white`}>
							{option.icon}
							<span>{option.label}</span>
						</Link>
					)
				})}
			</div>
		</div>
	);
}
